import { Link } from "react-router-dom";
import { imageUrl } from "@/lib/lamka";
import { timeLabel } from "@/lib/chat";

export const ConversationList = ({ items, activeId, userId, loading }) => {
  if (loading) return <p className="px-5 py-8 text-sm text-[#71717A]">Loading conversations…</p>;
  if (!items.length)
    return (
      <div data-testid="conversations-empty" className="px-5 py-10">
        <p className="font-display text-xl mb-2">No messages yet.</p>
        <p className="text-sm text-[#71717A]">Open any item and tap “Message seller” to start a chat.</p>
      </div>
    );
  return (
    <ul data-testid="conversation-list">
      {items.map((c) => {
        const iAmSeller = c.seller_id === userId;
        const other = iAmSeller ? c.buyer_name : c.seller_name;
        return (
          <li key={c.id}>
            <Link
              to={`/messages/${c.id}`}
              data-testid={`conversation-item-${c.id}`}
              className={`flex gap-3 px-5 py-4 border-b border-[#0F0F0F]/5 transition-colors ${activeId === c.id ? "bg-[#F5EFE6]" : "hover:bg-[#F5EFE6]/60"}`}
            >
              <div className="h-14 w-11 shrink-0 bg-[#F5EFE6] overflow-hidden">
                {c.listing_image && <img src={imageUrl(c.listing_image)} alt="" className="h-full w-full object-cover" />}
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex justify-between gap-2">
                  <p className={`text-sm truncate ${c.unread ? "font-semibold" : "font-medium"}`}>{other || "Lamka member"}</p>
                  <span className="font-mono text-[10px] text-[#71717A] shrink-0">{timeLabel(c.last_message_at || c.created_at)}</span>
                </div>
                <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-[#B38F46] truncate mt-0.5">{iAmSeller ? "Selling · " : ""}{c.listing_title}</p>
                <div className="flex items-center gap-2 mt-1">
                  <p className="text-xs text-[#71717A] truncate flex-1">{c.last_message || "Say hello"}</p>
                  {c.unread && <span data-testid={`conversation-unread-${c.id}`} className="h-2 w-2 rounded-full bg-[#C5A059] shrink-0" />}
                </div>
              </div>
            </Link>
          </li>
        );
      })}
    </ul>
  );
};
